import { Pipe, PipeTransform } from '@angular/core';

// Converts a string from 'camelCase', 'PascalCase', 'snake_case', 'kebab-case' to 'Sentence case'
@Pipe({
	name: 'sentenceCase',
	standalone: true,
})
export class SentenceCasePipe implements PipeTransform {
	transform(str: string): string {
		// If the string is short and all caps, leave it be
		if (!str || (str.length <= 5 && !str.replace(/[A-Z]/g, ''))) {
			return str;
		}
		// Replace dashes, dots, and underscores with spaces
		str = str.replace(/[-_.]/g, ' ');
		let newString = '';
		if (str === str.toUpperCase()) {
			// Convert an all uppercase string to lower case
			newString += str.toLowerCase();
		} else {
			// Add spaces before the start of each capital letter
			for (const ch of str) {
				if (ch === ch.toUpperCase()) {
					newString += ' ';
				}
				newString += ch.toLowerCase();
			}
		}
		// Remove trailing and repeating spaces
		newString = newString.replace(/\s+/g, ' ').trim();
		// Capitalize the first letter of the string
		newString = newString.charAt(0).toUpperCase() + newString.slice(1, newString.length);
		return newString;
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
